(function () {
  "use strict";
  var L = window.Lagom;
  if (!L || !L.q || L.cardsLoaded) return;
  L.cardsLoaded = !0;
  var q = L.q,
    qa = L.qa,
    motionOff = L.motionOff,
    MOTION = L.MOTION,
    CAPTURE = L.CAPTURE;
  function boot() {
    (window.innerWidth >= 768 &&
      qa(".scards[data-glide]").forEach(function (w) {
        (w.setAttribute("data-drift", "1"),
          w.setAttribute("data-speed", "0"),
          w.setAttribute("data-snap", ""));
      }),
      qa(".scards[data-drift]").forEach(function (wrap) {
        var cards = qa(".scard", wrap);
        if (!cards.length) return;
        var snap = wrap.hasAttribute("data-snap"),
          nav = wrap.parentNode.querySelector(".scards__nav");
        nav && !snap && (nav.remove(), (nav = null));
        var rowsN = Math.max(
            1,
            parseInt(wrap.getAttribute("data-drift"), 10) || 1,
          ),
          speed = wrap.hasAttribute("data-speed")
            ? parseFloat(wrap.getAttribute("data-speed")) || 0
            : 20;
        wrap.classList.add("is-drift");
        var holder = document.createElement("div");
        holder.className = "drift__rows";
        for (var rows = [], r = 0; r < rowsN; r++) {
          var row = document.createElement("div");
          row.className = "drift__row";
          var track = document.createElement("div");
          ((track.className = "drift__track"),
            cards.forEach(function (c, i) {
              i % rowsN === r && track.appendChild(c);
            }),
            row.appendChild(track),
            holder.appendChild(row),
            rows.push({
              track: track,
              originals: qa(".scard", track),
              setW: 0,
              shift: 0,
            }));
        }
        ((wrap.textContent = ""), wrap.appendChild(holder));
        function gapOf(t) {
          return parseFloat(getComputedStyle(t).columnGap) || 0;
        }
        function layout() {
          var vw = wrap.clientWidth || window.innerWidth;
          rows.forEach(function (rw, ri) {
            qa(".is-clone", rw.track).forEach(function (k2) {
              k2.remove();
            });
            var g = gapOf(rw.track),
              w = 0;
            (rw.originals.forEach(function (c) {
              w += c.offsetWidth + g;
            }),
              (rw.setW = w || 1));
            for (
              var copies = Math.max(1, Math.ceil((vw * 2) / rw.setW) + 1),
                k = 0;
              k < copies;
              k++
            )
              rw.originals.forEach(function (c) {
                var cl = c.cloneNode(!0);
                (cl.classList.add("is-clone"),
                  cl.setAttribute("aria-hidden", "true"),
                  qa("button, a", cl).forEach(function (e) {
                    e.setAttribute("tabindex", "-1");
                  }),
                  rw.track.appendChild(cl));
              });
            ((rw.step = rw.originals[0] ? rw.originals[0].offsetWidth + g : 1),
              (rw.shift = snap
                ? -(vw - (rw.step - g)) / 2
                : ri % 2
                  ? rw.step / 2
                  : 0));
          });
          var all = qa(".scard", wrap);
          all.forEach(function (c) {
            c.style.height = "";
          });
          var h = 0;
          (cards.forEach(function (c) {
            h = Math.max(h, c.offsetHeight);
          }),
            all.forEach(function (c) {
              c.style.height = h + "px";
            }),
            paint());
        }
        var x = 0,
          vel = -speed,
          base = -speed,
          last = 0,
          raf = 0,
          onScreen = !1,
          hover = !1,
          drag = null,
          moved = !1,
          tween = null;
        motionOff() && ((base = 0), (vel = 0));
        function step() {
          return rows[0].step || 1;
        }
        function tweenTo(target, dur, inOut) {
          ((tween = {
            from: x,
            to: target,
            t0: 0,
            dur: motionOff() ? 1 : dur,
            inOut: inOut,
          }),
            (vel = 0),
            run());
        }
        nav &&
          ((nav.hidden = !1),
          qa(".scards__arrow", nav).forEach(function (b) {
            b.addEventListener("click", function () {
              var from = tween ? tween.to : Math.round(x / step()) * step();
              tweenTo(from - Number(b.dataset.dir) * step(), 700, !0);
            });
          }));
        function paint() {
          rows.forEach(function (rw) {
            var p =
              ((((x - rw.shift) % rw.setW) + rw.setW) % rw.setW) - rw.setW;
            rw.track.style.transform =
              "translate3d(" + p.toFixed(2) + "px,0,0)";
          });
        }
        function frame(t) {
          raf = 0;
          var dt = last ? Math.min(0.05, (t - last) / 1e3) : 0;
          last = t;
          var idle = !1;
          if (tween) {
            tween.t0 || (tween.t0 = t);
            var k = Math.min(1, (t - tween.t0) / tween.dur),
              e = tween.inOut
                ? k < 0.5
                  ? 4 * k * k * k
                  : 1 - Math.pow(-2 * k + 2, 3) / 2
                : 1 - Math.pow(1 - k, 3);
            ((x = tween.from + (tween.to - tween.from) * e),
              k >= 1 && ((tween = null), (idle = snap)));
          } else if (!drag) {
            var target = hover && !snap ? 0 : base;
            if (
              ((vel +=
                (target - vel) *
                (1 -
                  Math.exp(
                    -dt *
                      (Math.abs(vel) > Math.abs(base) * 2
                        ? snap
                          ? 3.2
                          : 1.6
                        : 3),
                  ))),
              (x += vel * dt),
              snap && Math.abs(vel) < 60)
            ) {
              var near = Math.round(x / step()) * step();
              Math.abs(near - x) < 0.5
                ? ((x = near), (vel = 0), (idle = !0))
                : tweenTo(near, 420, !1);
            }
          }
          (paint(),
            onScreen &&
              !document.hidden &&
              !idle &&
              (raf = window.requestAnimationFrame(frame)));
        }
        function run() {
          !raf &&
            onScreen &&
            !document.hidden &&
            ((last = 0), (raf = window.requestAnimationFrame(frame)));
        }
        (wrap.addEventListener("pointerdown", function (e) {
          !e.isPrimary ||
            (e.pointerType === "mouse" && e.button !== 0) ||
            ((drag = {
              id: e.pointerId,
              x: e.clientX,
              y: e.clientY,
              lx: e.clientX,
              lt: e.timeStamp,
              on: !1,
              v: 0,
            }),
            (moved = !1));
        }),
          wrap.addEventListener("pointermove", function (e) {
            if (!(!drag || e.pointerId !== drag.id)) {
              var dx = e.clientX - drag.x,
                dy = e.clientY - drag.y;
              if (!drag.on) {
                if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
                  drag = null;
                  return;
                }
                if (Math.abs(dx) < 6) return;
                ((drag.on = !0),
                  (moved = !0),
                  (vel = 0),
                  (tween = null),
                  wrap.classList.add("is-dragging"));
                try {
                  wrap.setPointerCapture(e.pointerId);
                } catch (err) {}
              }
              var step2 = e.clientX - drag.lx,
                dts = Math.max(1, e.timeStamp - drag.lt) / 1e3;
              ((x += step2),
                (drag.v = drag.v * 0.6 + (step2 / dts) * 0.4),
                (drag.lx = e.clientX),
                (drag.lt = e.timeStamp),
                paint());
            }
          }));
        function end(e) {
          !drag ||
            e.pointerId !== drag.id ||
            (drag.on &&
              ((vel = Math.max(-4e3, Math.min(4e3, drag.v))), (tween = null)),
            (drag = null),
            wrap.classList.remove("is-dragging"),
            run());
        }
        (wrap.addEventListener("pointerup", end),
          wrap.addEventListener("pointercancel", end),
          wrap.addEventListener(
            "click",
            function (e) {
              moved && (e.preventDefault(), e.stopPropagation(), (moved = !1));
            },
            !0,
          ),
          wrap.addEventListener(
            "touchmove",
            function (e) {
              drag && drag.on && e.cancelable && e.preventDefault();
            },
            { passive: !1 },
          ),
          wrap.addEventListener(
            "wheel",
            function (e) {
              Math.abs(e.deltaX) <= Math.abs(e.deltaY) ||
                (e.preventDefault(),
                (tween = null),
                (x -= e.deltaX),
                (vel = -e.deltaX * 30),
                paint(),
                run());
            },
            { passive: !1 },
          ),
          wrap.addEventListener("pointerenter", function (e) {
            e.pointerType === "mouse" && (hover = !0);
          }),
          wrap.addEventListener("pointerleave", function () {
            hover = !1;
          }),
          "IntersectionObserver" in window
            ? new IntersectionObserver(
                function (es) {
                  ((onScreen = es[0].isIntersecting), run());
                },
                { rootMargin: "100px 0px" },
              ).observe(wrap)
            : (onScreen = !0),
          document.addEventListener("visibilitychange", run),
          layout(),
          run());
        var lw = window.innerWidth;
        (window.addEventListener("resize", function () {
          window.innerWidth !== lw && ((lw = window.innerWidth), layout());
        }),
          window.addEventListener("load", layout));
      }),
      qa(".scards[data-marquee]").forEach(function (wrap) {
        var cards = qa(".scard", wrap);
        if (!cards.length) return;
        var nav = wrap.parentNode.querySelector(".scards__nav");
        wrap.classList.add("is-marquee");
        var inner = document.createElement("div");
        ((inner.className = "marquee__rows"),
          [0, 1].forEach(function (r) {
            var row = document.createElement("div");
            ((row.className = "marquee__row" + (r ? " is-offset" : "")),
              cards.forEach(function (c, i) {
                i % 2 === r && row.appendChild(c);
              }),
              inner.appendChild(row));
          }),
          (wrap.textContent = ""),
          wrap.appendChild(inner));
        function size() {
          cards.forEach(function (c) {
            c.style.height = "";
          });
          var h = 0;
          (cards.forEach(function (c) {
            h = Math.max(h, c.offsetHeight);
          }),
            cards.forEach(function (c) {
              c.style.height = h + "px";
            }),
            ends());
        }
        var btns = nav ? qa(".scards__arrow", nav) : [];
        function ends() {
          var max = wrap.scrollWidth - wrap.clientWidth - 2;
          btns.forEach(function (b) {
            b.disabled =
              Number(b.dataset.dir) < 0
                ? wrap.scrollLeft <= 2
                : wrap.scrollLeft >= max;
          });
        }
        (nav &&
          ((nav.hidden = !1),
          nav.classList.add("is-glider"),
          btns.forEach(function (b) {
            b.addEventListener("click", function () {
              var step =
                (cards[0].offsetWidth +
                  (parseFloat(
                    getComputedStyle(cards[0].parentNode).columnGap,
                  ) || 14)) *
                Math.max(
                  1,
                  Math.floor(wrap.clientWidth / cards[0].offsetWidth) - 1,
                );
              wrap.scrollBy({
                left: Number(b.dataset.dir) * step,
                behavior: motionOff() ? "auto" : "smooth",
              });
            });
          })),
          wrap.addEventListener(
            "scroll",
            function () {
              window.requestAnimationFrame(ends);
            },
            { passive: !0 },
          ),
          size());
        var lw = window.innerWidth;
        (window.addEventListener("resize", function () {
          window.innerWidth !== lw && ((lw = window.innerWidth), size());
        }),
          window.addEventListener("load", size));
      }),
      qa(".scards[data-bricks]").forEach(function (wrap) {
        var cards = qa(".scard", wrap),
          n = cards.length;
        if (!n) return;
        var more = wrap.parentNode.querySelector("[data-bricks-more]"),
          nav = wrap.parentNode.querySelector(".scards__nav");
        nav && nav.remove();
        var startRows =
            parseInt(wrap.getAttribute("data-bricks") || "3", 10) || 3,
          k = 0,
          rows = 0,
          laid = 0,
          seen = !1;
        (wrap.classList.add("is-bricks"),
          cards.forEach(function (c) {
            c.classList.add("brick");
          }));
        function perRow() {
          var w = window.innerWidth;
          return w >= 1024 ? 4 : w >= 768 ? 3 : 2;
        }
        function rowSize(r) {
          return Math.max(1, r % 2 ? k - 1 : k);
        }
        function count(r) {
          for (var t = 0, i = 0; i < r; i++) t += rowSize(i);
          return Math.min(t, n);
        }
        function build(animateFrom) {
          wrap.textContent = "";
          for (var shown = count(rows), i = 0, r = 0; i < shown; r++) {
            var row = document.createElement("div");
            row.className = "bricks__row";
            for (var j = 0; j < rowSize(r) && i < shown; j++, i++)
              row.appendChild(cards[i]);
            wrap.appendChild(row);
          }
          (wrap.style.setProperty("--brick-k", String(k)),
            cards.forEach(function (c) {
              c.style.height = "";
            }));
          for (var h = 0, a = 0; a < shown; a++)
            h = Math.max(h, cards[a].offsetHeight);
          for (var b = 0; b < shown; b++) cards[b].style.height = h + "px";
          (more && (more.hidden = shown >= n),
            animateFrom != null && lay(animateFrom, shown),
            (laid = Math.max(laid, shown)));
        }
        function lay(from, to) {
          if (motionOff()) {
            for (var i = from; i < to; i++)
              cards[i].classList.remove("is-waiting");
            return;
          }
          for (var j = from; j < to; j++)
            (cards[j].classList.add("is-waiting"),
              (cards[j].style.transitionDelay = ""));
          wrap.offsetWidth;
          for (var m = from; m < to; m++)
            ((cards[m].style.transitionDelay = (m - from) * 70 + "ms"),
              cards[m].classList.remove("is-waiting"));
        }
        function setup() {
          var nk = perRow();
          if (nk !== k) {
            var shown = count(rows);
            for (
              k = nk, rows = startRows;
              count(rows) < Math.max(shown, 1) && count(rows) < n;
            )
              rows++;
            if ((build(null), !seen))
              for (var i = 0; i < count(rows); i++)
                cards[i].classList.add("is-waiting");
          }
        }
        setup();
        var go = function () {
          seen || ((seen = !0), lay(0, count(rows)));
        };
        if ("IntersectionObserver" in window && !motionOff()) {
          var io = new IntersectionObserver(
            function (e) {
              e[0].isIntersecting && (io.disconnect(), go());
            },
            { threshold: 0.15 },
          );
          io.observe(wrap);
        } else go();
        more &&
          more.addEventListener("click", function () {
            var from = count(rows);
            ((rows += 2), build(from));
          });
        var lw = window.innerWidth;
        (window.addEventListener("resize", function () {
          if (window.innerWidth !== lw) {
            lw = window.innerWidth;
            var keep = seen;
            (setup(),
              keep &&
                cards.forEach(function (c) {
                  c.classList.remove("is-waiting");
                }));
          }
        }),
          window.addEventListener("load", function () {
            build(null);
          }));
      }),
      qa(".scards").forEach(function (wrap) {
        if (
          wrap.hasAttribute("data-bricks") ||
          wrap.hasAttribute("data-marquee") ||
          wrap.hasAttribute("data-drift")
        )
          return;
        var cards = qa(".scard", wrap),
          n = cards.length;
        if (n < 2) return;
        var mq = window.matchMedia("(max-width: 767px)"),
          pos = 0,
          anim = 0,
          lastTouch = 0,
          visible = !1,
          step = 100,
          cur = -1,
          drawQueued = !1,
          dots = document.createElement("div");
        ((dots.className = "scards__dots"),
          dots.setAttribute("role", "group"),
          dots.setAttribute("aria-label", window.OfflineI18n.reviewChoose));
        var dotEls = cards.map(function (c, i) {
          var d = document.createElement("button");
          return (
            (d.type = "button"),
            (d.className = "scards__dot"),
            d.setAttribute("aria-label", window.OfflineI18n.review + (i + 1)),
            d.addEventListener("click", function () {
              ((lastTouch = Date.now()), to(pos + wrapD(i - pos), !0));
            }),
            dots.appendChild(d),
            d
          );
        });
        wrap.parentNode.insertBefore(dots, wrap.nextSibling);
        function wrapD(d) {
          return ((d = ((d % n) + n) % n), d >= n / 2 ? d - n : d);
        }
        function render() {
          if (mq.matches) {
            var front = ((Math.round(pos) % n) + n) % n;
            (cards.forEach(function (c, i) {
              var d = wrapD(i - pos),
                ad = Math.abs(d),
                a = Math.min(ad, 1),
                e = a * (2 - a),
                x = d * step,
                sc = 1 - 0.16 * e - (ad > 1 ? 0.06 * (ad - 1) : 0),
                ry = Math.max(-1, Math.min(1, d)) * 22;
              ((c.style.transform =
                "translate3d(" +
                x.toFixed(1) +
                "px,0,0) perspective(1000px) rotateY(" +
                ry.toFixed(2) +
                "deg) scale(" +
                sc.toFixed(4) +
                ")"),
                (c.style.opacity =
                  ad <= 1 ? "1" : Math.max(0, 1 - (ad - 1) * 2).toFixed(3)),
                (c.style.zIndex = String(10 - Math.round(ad * 3))));
            }),
              dotEls.forEach(function (dt, k) {
                var d = wrapD(k - pos),
                  ad = Math.abs(d),
                  a = 1 - Math.min(ad, 1),
                  x =
                    (d < 0 ? -1 : 1) * (ad <= 1 ? 23 * ad : 23 + 16 * (ad - 1));
                ((dt.style.transform =
                  "translate3d(" + x.toFixed(1) + "px,0,0)"),
                  (dt.style.opacity =
                    ad <= 2 ? "1" : Math.max(0, 1 - (ad - 2) * 2).toFixed(3)),
                  dt.style.setProperty("--a", a.toFixed(3)));
              }),
              front !== cur &&
                ((cur = front),
                dotEls.forEach(function (d, k) {
                  d.setAttribute("aria-pressed", k === cur ? "true" : "false");
                }),
                cards.forEach(function (c, k) {
                  (c.classList.toggle("is-active", k === cur),
                    c.setAttribute(
                      "aria-hidden",
                      k === cur ? "false" : "true",
                    ));
                })));
          }
        }
        function to(target, soft) {
          window.cancelAnimationFrame(anim);
          var from = pos,
            t0 = performance.now(),
            dist = Math.abs(target - from),
            dur = motionOff() ? 0 : soft ? 900 : 380 + 220 * Math.min(1, dist);
          if (!dur) {
            ((pos = target), render());
            return;
          }
          (function f(now) {
            var k = Math.min(1, (now - t0) / dur),
              e = soft
                ? k < 0.5
                  ? 4 * k * k * k
                  : 1 - Math.pow(-2 * k + 2, 3) / 2
                : 1 - Math.pow(1 - k, 3);
            ((pos = from + (target - from) * e),
              render(),
              k < 1 && (anim = window.requestAnimationFrame(f)));
          })(t0);
        }
        function layout() {
          if (!mq.matches) {
            ((wrap.style.height = ""),
              cards.forEach(function (c) {
                ((c.style.transform =
                  c.style.opacity =
                  c.style.zIndex =
                  c.style.height =
                  c.style.background =
                    ""),
                  c.classList.remove("is-active"),
                  c.removeAttribute("aria-hidden"));
              }),
              (cur = -1));
            return;
          }
          cards.forEach(function (c) {
            c.style.height = "";
          });
          var h = 0;
          (cards.forEach(function (c) {
            h = Math.max(h, c.offsetHeight);
          }),
            cards.forEach(function (c) {
              c.style.height = h + "px";
            }),
            (wrap.style.height = h + "px"),
            (step = cards[0].offsetWidth * 0.36),
            (cur = -1),
            render());
        }
        var drag = null;
        (wrap.addEventListener("pointerdown", function (ev) {
          if (!(
            !mq.matches ||
            (ev.pointerType === "mouse" && ev.button !== 0)
          )) {
            if (
              !ev.isPrimary ||
              (window.Lagom && Lagom.zoomed && Lagom.zoomed())
            ) {
              if (drag) {
                var d0 = drag;
                ((drag = null), wrap.classList.remove("is-dragging"));
                try {
                  wrap.releasePointerCapture(d0.id);
                } catch (e) {}
                to(Math.round(pos));
              }
              return;
            }
            ((lastTouch = Date.now()),
              window.cancelAnimationFrame(anim),
              (drag = {
                id: ev.pointerId,
                x: ev.clientX,
                y: ev.clientY,
                p0: pos,
                on: !1,
                pts: [[ev.timeStamp, ev.clientX]],
                el: ev.target,
              }));
          }
        }),
          wrap.addEventListener("pointermove", function (ev) {
            if (!(!drag || ev.pointerId !== drag.id)) {
              var dx = ev.clientX - drag.x,
                dy = ev.clientY - drag.y;
              if (!drag.on) {
                if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
                  ((drag = null), to(Math.round(pos)));
                  return;
                }
                if (Math.abs(dx) < 6) return;
                ((drag.on = !0), wrap.classList.add("is-dragging"));
                try {
                  wrap.setPointerCapture(ev.pointerId);
                } catch (e) {}
              }
              (drag.pts.push([ev.timeStamp, ev.clientX]),
                drag.pts.length > 6 && drag.pts.shift(),
                (pos = drag.p0 - dx / (step * 2.2)),
                drawQueued ||
                  ((drawQueued = !0),
                  window.requestAnimationFrame(function () {
                    ((drawQueued = !1), render());
                  })));
            }
          }),
          wrap.addEventListener(
            "touchmove",
            function (e) {
              drag &&
                drag.on &&
                e.touches.length < 2 &&
                e.cancelable &&
                e.preventDefault();
            },
            { passive: !1 },
          ));
        function end(ev) {
          if (!(!drag || ev.pointerId !== drag.id)) {
            var d = drag;
            if (
              ((drag = null),
              (lastTouch = Date.now()),
              wrap.classList.remove("is-dragging"),
              !d.on)
            ) {
              if (ev.type === "pointerup") {
                var c = d.el.closest && d.el.closest(".scard"),
                  i = cards.indexOf(c);
                if (i >= 0 && i !== cur) {
                  to(pos + wrapD(i - pos));
                  return;
                }
              }
              to(Math.round(pos));
              return;
            }
            var a = d.pts[0],
              b = d.pts[d.pts.length - 1],
              v = (b[1] - a[1]) / Math.max(1, b[0] - a[0]),
              moved = pos - d.p0,
              base = Math.round(d.p0),
              target;
            (Math.abs(v) > 0.35
              ? (target = base + (v < 0 ? 1 : -1))
              : Math.abs(moved) > 0.25
                ? (target = base + (moved > 0 ? 1 : -1))
                : (target = base),
              to(target));
          }
        }
        (wrap.addEventListener("pointerup", end),
          wrap.addEventListener("pointercancel", end),
          "IntersectionObserver" in window
            ? new IntersectionObserver(
                function (e) {
                  visible = e[0].isIntersecting;
                },
                { threshold: 0.4 },
              ).observe(wrap)
            : (visible = !0),
          motionOff() ||
            window.setInterval(function () {
              mq.matches &&
                visible &&
                !drag &&
                !document.hidden &&
                Date.now() - lastTouch > 8e3 &&
                to(Math.round(pos) + 1, !0);
            }, 5e3),
          mq.addEventListener("change", layout),
          window.addEventListener("load", layout));
        var lw = 0;
        (window.addEventListener("resize", function () {
          window.innerWidth !== lw && ((lw = window.innerWidth), layout());
        }),
          document.fonts &&
            document.fonts.ready &&
            document.fonts.ready.then(layout),
          (lw = window.innerWidth),
          layout());
      }),
      qa(".scards").forEach(function (wrap) {
        if (
          wrap.hasAttribute("data-bricks") ||
          wrap.hasAttribute("data-marquee") ||
          wrap.hasAttribute("data-drift")
        )
          return;
        var nav = wrap.parentNode.querySelector(".scards__nav");
        if (!nav) return;
        var real = qa(".scard", wrap),
          n = real.length;
        if (n < 2) return;
        function copy(c) {
          var k = c.cloneNode(!0);
          // Desktop loop copies must not inherit the mobile stack's inline pose.
          // They are created while the mobile controller may already be active.
          ["transform", "opacity", "z-index", "height", "background"].forEach(function (property) {
            k.style.removeProperty(property);
          });
          k.classList.remove("is-active", "is-prev", "is-next");
          return (
            k.classList.add("is-clone"),
            k.setAttribute("aria-hidden", "true"),
            qa("button, a", k).forEach(function (e) {
              e.setAttribute("tabindex", "-1");
            }),
            k.removeAttribute("data-shopify-editor-block"),
            k
          );
        }
        (real.forEach(function (c) {
          wrap.appendChild(copy(c));
        }),
          real
            .slice()
            .reverse()
            .forEach(function (c) {
              wrap.insertBefore(copy(c), wrap.firstChild);
            }));
        var mq = window.matchMedia("(min-width: 768px)"),
          btns = qa(".scards__arrow", nav),
          idle = 0,
          setW = 0,
          x0 = 0;
        function measure() {
          setW = real[0].offsetLeft - wrap.firstElementChild.offsetLeft;
          var r = real[0].getBoundingClientRect(),
            w = wrap.getBoundingClientRect();
          ((x0 =
            wrap.scrollLeft +
            (r.left + r.width / 2) -
            (w.left + wrap.clientWidth / 2)),
            (nav.hidden = !mq.matches));
        }
        function settle() {
          if (((idle = 0), !(!mq.matches || !setW))) {
            var x = wrap.scrollLeft,
              half = real[0].offsetWidth / 2;
            x < x0 - half
              ? (wrap.scrollLeft = x + setW)
              : x >= x0 + setW - half && (wrap.scrollLeft = x - setW);
          }
        }
        function home() {
          (measure(), mq.matches && (wrap.scrollLeft = x0));
        }
        var gliding = 0;
        function glide(dx) {
          if (motionOff()) {
            ((wrap.scrollLeft += dx), settle());
            return;
          }
          window.cancelAnimationFrame(gliding);
          var from = wrap.scrollLeft,
            t0 = performance.now(),
            dur = 800;
          ((wrap.style.scrollSnapType = "none"),
            (function f(now) {
              var k = Math.min(1, (now - t0) / dur),
                e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
              ((wrap.scrollLeft = from + dx * e),
                k < 1
                  ? (gliding = window.requestAnimationFrame(f))
                  : ((gliding = 0),
                    (wrap.style.scrollSnapType = ""),
                    settle()));
            })(t0));
        }
        (btns.forEach(function (b) {
          b.addEventListener("click", function () {
            if (!gliding) {
              settle();
              var gap = parseFloat(getComputedStyle(wrap).columnGap) || 0;
              glide(Number(b.dataset.dir) * (real[0].offsetWidth + gap));
            }
          });
        }),
          "onscrollend" in window
            ? wrap.addEventListener("scrollend", settle)
            : wrap.addEventListener(
                "scroll",
                function () {
                  (window.clearTimeout(idle),
                    (idle = window.setTimeout(settle, 160)));
                },
                { passive: !0 },
              ));
        var lw = window.innerWidth;
        (window.addEventListener("resize", function () {
          window.innerWidth !== lw && ((lw = window.innerWidth), home());
        }),
          mq.addEventListener("change", home),
          window.addEventListener("load", home),
          home());
      }),
      (function () {
        var vids = qa(".scard__video video");
        if (!vids.length) return;
        var seen = new Map(),
          noInline = !1;
        vids.forEach(function (v) {
          ((v.muted = !0),
            (v.defaultMuted = !0),
            (v.playsInline = !0),
            (v.controls = !1),
            v.setAttribute("playsinline", ""),
            v.setAttribute("webkit-playsinline", ""),
            v.setAttribute("muted", ""));
          try {
            v.disablePictureInPicture = !0;
          } catch (e) {}
          var out = function () {
            noInline = !0;
            try {
              v.webkitExitFullscreen && v.webkitExitFullscreen();
            } catch (e) {}
            try {
              document.fullscreenElement &&
                document.exitFullscreen &&
                document.exitFullscreen();
            } catch (e) {}
            try {
              document.pictureInPictureElement &&
                document.exitPictureInPicture &&
                document.exitPictureInPicture();
            } catch (e) {}
            vids.forEach(function (o) {
              o.paused || o.pause();
            });
          };
          (v.addEventListener("webkitbeginfullscreen", out),
            v.addEventListener("enterpictureinpicture", out),
            v.addEventListener("fullscreenchange", function () {
              document.fullscreenElement === v && out();
            }));
        });
        function front(v) {
          var c = v.closest(".scard");
          return c.classList.contains("is-clone")
            ? !0
            : !c.hasAttribute("aria-hidden") ||
                c.getAttribute("aria-hidden") === "false";
        }
        function sync(v) {
          var want =
            seen.get(v) &&
            !document.hidden &&
            front(v) &&
            ((!motionOff() && !noInline) || v.dataset.user === "1");
          if (want) {
            !v.src && v.dataset.src && (v.src = v.dataset.src);
            var p = v.play();
            p && p.catch && p.catch(function () {});
          } else v.paused || v.pause();
        }
        function all() {
          vids.forEach(sync);
        }
        if (
          (vids.forEach(function (v) {
            v.addEventListener("error", function () {
              var rest = (v.dataset.fallback || "").split(" ").filter(Boolean);
              rest.length &&
                ((v.dataset.src = rest.shift()),
                (v.dataset.fallback = rest.join(" ")),
                (v.src = v.dataset.src),
                sync(v));
            });
          }),
          "IntersectionObserver" in window)
        ) {
          var io = new IntersectionObserver(
            function (es) {
              es.forEach(function (e) {
                (seen.set(e.target, e.isIntersecting), sync(e.target));
              });
            },
            { rootMargin: "200px 0px", threshold: 0.01 },
          );
          vids.forEach(function (v) {
            io.observe(v);
          });
        } else
          (vids.forEach(function (v) {
            seen.set(v, !0);
          }),
            all());
        (document.addEventListener("visibilitychange", all),
          "MutationObserver" in window &&
            qa(".scards").forEach(function (wrap) {
              new MutationObserver(all).observe(wrap, {
                attributes: !0,
                subtree: !0,
                attributeFilter: ["aria-hidden"],
              });
            }),
          vids.forEach(function (v) {
            var b = v.parentNode.querySelector(".scard__sound");
            (motionOff() &&
              v.addEventListener("click", function () {
                ((v.dataset.user = "1"), sync(v));
              }),
              b &&
                b.addEventListener("click", function (ev) {
                  ev.stopPropagation();
                  var on = v.muted;
                  (vids.forEach(function (o) {
                    o.muted = !0;
                    var ob = o.parentNode.querySelector(".scard__sound");
                    ob &&
                      (ob.setAttribute("aria-pressed", "false"),
                      ob.setAttribute("aria-label", window.OfflineI18n.soundOn));
                  }),
                    (v.muted = !on),
                    b.setAttribute("aria-pressed", on ? "true" : "false"),
                    b.setAttribute("aria-label", on ? window.OfflineI18n.soundOff : window.OfflineI18n.soundOn),
                    on && ((v.dataset.user = "1"), sync(v)));
                }));
          }));
      })());
  }
  var started = !1;
  function start() {
    started || ((started = !0), boot());
  }
  start();
})();
